import { Box } from "@material-ui/core";
import React, { useState } from "react";
import InboxQuestContent from "./InboxQuestContent";
import { InboxQuestComponentProps } from "./map-inbox-quests";

const InboxQuest: React.FC<InboxQuestComponentProps> = (props: InboxQuestComponentProps) => {
	const [show, setShow] = useState(false);

	return (
		<Box
			onMouseEnter={() => {
				setShow(true);
			}}
			onMouseLeave={() => {
				setShow(false);
			}}
		>
			<InboxQuestContent {...props} isVisible={show} rowIndex={props.index} />
		</Box>
	);
};

export default InboxQuest;
